<script setup>
import AutocompleteFilter from '@/components/widgets/AutocompleteFilter.vue';
import { ref, inject, onMounted } from 'vue';

const backendApi = inject('backendApi');

const emit = defineEmits(['update', 'update:focused']);
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);
const loading = ref(true);
const packTypes = ref([]);
const showRetryButton = ref(false);
const searchQuery = ref('');

const getPackTypes = () => {
    cleanData();

    backendApi()
        .packTypes()
        .index({
            pattern: searchQuery.value,
            active: true
        })
        .then(success, fail)
        .finally(() => (loading.value = false));

    function success(response) {
        packTypes.value = response.data;
    }

    function fail() {
        showRetryButton.value = true;
    }
};

const cleanData = () => {
    packTypes.value = [];
    loading.value = true;
    showRetryButton.value = false;
};

onMounted(() => getPackTypes());
</script>

<template>
    <AutocompleteFilter
        v-model="selected"
        v-model:search="searchQuery"
        :items="packTypes"
        item-title="name"
        item-value="id"
        :label="hideLabel ? '' : $t('PackType')"
        :loading="loading"
        :show-retry-button="showRetryButton"
        @update="emit('update', selected)"
        @preparing-search="cleanData"
        @search="getPackTypes"
        @retry="getPackTypes"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-slot:default="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="`${item.raw.name}`"
            ></v-list-item>
        </template>
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </AutocompleteFilter>
</template>
